






















































import {
  defineComponent,
  ref,
} from '@nuxtjs/composition-api';
import { PropType } from 'vue';
import { SfImage } from '~/components/StorefrontUi';
import type { CategoryTree } from '~/composables';
import { addBasePath } from '~/helpers/addBasePath';

import { useUiHelpers } from '~/composables';

export default defineComponent({
  name: 'ProductCategoriesAccordion',
  components: {
    SfImage,
  },
  props: {
    categories: {
      type: Array as PropType<CategoryTree[]>,
      required: true,
    },
  },
  setup() {
    const isOpened = ref(false);
    const { getCatLink } = useUiHelpers();

    return {
      getCatLink,
      isOpened,
      addBasePath,
    };
  },
});
